export default __webpack_public_path__ + "static/media/icon3.b46fd428.jpg";